<template>
    <header class="header" :class="['header', { 'shadow-header': isProContain }]">
        <div class="isNavMaxShow">
            <div style="display: flex; align-items: center;">
                <div class="headerLogo headerIcon"><img src="../assets/img1.png" /></div>
                <div>
                    <nav>
                        <ul>
                            <li><router-link to="/">网站首页</router-link></li>
                            <li><router-link to="/about">公司介绍</router-link></li>
                            <li><router-link to="/products">产品中心</router-link></li>
                            <li><router-link to="/team">精英团队</router-link></li>
                            <li><router-link to="/news">新闻动态</router-link></li>
                            <li><router-link to="/contactUs">联系方式</router-link></li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
        <div class="isNavMInShow">
            <div class="headerPhone" :class="['headerPhone',{'phone-menu-active':!isShowPhoneMenu}]">
                <div class="headerIcon headerPhoneIcon1">
                    <img src="../assets/img1.png" />
                </div>
                <div class="headerIcon2 headerPhoneIcon2" @click="changeBackColor">
                    <img src="../assets/icon7.png" v-if="isShowPhoneMenu==true" />
                    <i class="el-icon-close closePhone" v-if="isShowPhoneMenu==false"></i>
                </div>
            </div>
        </div>
        <div class="phoneMenu" v-if="!isShowPhoneMenu">
            <div @click="goHome">网站首页</div>
            <div @click="goAbout">公司介绍</div>
            <div @click="goPro">产品中心</div>
            <div @click="goTeam">精英团队</div>
            <div @click="goNews">新闻动态</div>
            <div @click="goCon">联系我们</div>
        </div>
    </header>
</template>

<script>
    export default {
        name: 'Header',
        data() {
            return {
                isShowPhoneMenu: true
            };
        },
        computed: {
            // 判断当前路由是否是 'proContain'
            isProContain() {
                return this.$route.name === 'proContain'; // 请根据实际路由名称修改
            }
        },
        mounted() {
        },
        beforeDestroy() {
        },
        methods: {
            goHome() {
                this.$router.push({
                    path: '/'
                })
                this.isShowPhoneMenu = !this.isShowPhoneMenu;
            },
            goAbout() {
                this.$router.push({
                    path: '/about'
                })
                this.isShowPhoneMenu = !this.isShowPhoneMenu;
            },
            goPro() {
                this.$router.push({
                    path: '/products'
                })
                this.isShowPhoneMenu = !this.isShowPhoneMenu;
            },
            goTeam() {
                this.$router.push({
                    path: '/team'
                })
                this.isShowPhoneMenu = !this.isShowPhoneMenu;
            },
            goNews() {
                this.$router.push({
                    path: '/news'
                })
                this.isShowPhoneMenu = !this.isShowPhoneMenu;
            },
            goCon() {
                this.$router.push({
                    path: '/contactUs'
                })
                this.isShowPhoneMenu = !this.isShowPhoneMenu;
            },
            changeBackColor() {

                this.isShowPhoneMenu = !this.isShowPhoneMenu;
            }
        },
    };
</script>

<style scoped>
    .header {
        display: flex;
        align-items: end;
        color: #000000;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99999999 !important;
        width: 100%;
    }

    .header:hover {
        transition: 0.5s;
        background-color: #ffffff !important;
    }

    .header:hover nav ul li a {
        color: #333333;
    }

    .headerLogo {
        width: 4.1vw;
        padding-left: 7vw;
        padding-top: 1vw;
    }

    nav {
        width: 70vw;
        padding: 0;
    }

    nav ul {
        list-style-type: none;
        display: flex;
        justify-content: space-around;
        margin-bottom: 0px;
    }

    nav ul li {
        padding-bottom: 1.5vw;
        position: relative;
        /* 为了定位下划线 */
    }

    nav ul li a {
        color: white;
        text-decoration: none;
        font-size: 0.9vw;
    }

    nav ul li a:hover {
        color: #00A1E9 !important;
    }

    /* 下划线动画 */
    nav ul li a::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 0;
        height: 0.3vw;
        border-radius: 10px;
        background-color: #00A1E9;
        transition: width 0.3s ease, left 0.3s ease;
        transform: translateX(-50%);
        /* 保证横线从中心扩展 */
    }

    nav ul li a:hover::after {
        width: 100%;
        /* 让横线扩展到整个文字宽度 */
        left: 0;
        /* 从左侧开始扩展 */
        transform: translateX(0);
    }

    .shadow-header {
        box-shadow: 1px -3px 12px black;
    }.shadow-header a{
        color: #333333;
    }

    /* 针对电脑端 */
    @media screen and (min-width: 1024px) {
        .isNavMInShow {
            display: none;
        }
    }

    /* 针对手机端 */
    @media screen and (max-width: 1023px) {
        .isNavMaxShow {
            display: none;
        }

        .isNavMInShow {
            width: 100%;
        }


        .headerIcon {
            width: 6vw;
            height: 6vw;
        }

        .headerIcon2 {
            width: 4vw;
            height: 4vw;
        }

        .header:hover {
            background-color: transparent !important;
        }
    }

    .phoneMenu {
        position: fixed;
        width: 100%;
        top: 6vw;
        left: 0;
        z-index: 99;
        background-color: #29B8F8;
        /* padding-top: 7vw; */
        text-align: left;
        color: white;
    }

    .closePhone {
        font-weight: bold;
        color: white;
        font-size: 3vw;
    }

    .phoneMenu>div {
        padding: 2vw 0vw 0.5vw 0vw;
        margin-left: 4vw;
        border-bottom: 0.1px solid white;
    }

    .phoneMenu>div:last-child {
        border-bottom: none;
        padding-bottom: 5vw;
    }

    .phone-menu-active {
        background-color: #29B8F8 !important;
    }

    .headerPhone {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }

    .headerPhoneIcon1 {
        margin-left: 4vw;
    }

    .headerPhoneIcon2 {
        margin-right: 4vw;
    }
</style>